function scrollAni(ref, type, aim = 0, duration = 500) {
    let aniTimer = null;
    let animation = (ref, type, duration, aim) => {
        cancelAnimationFrame(aniTimer);
        let distance = ref[type] - aim;
        let start = Math.max(distance, ref[type]);
        let startTime = +new Date();
        let time = duration;
        let aniFn = () => {
            let s = time - Math.max(0, time - (+new Date() - startTime));
            ref[type] = start - (distance * s) / time;
            aniTimer = requestAnimationFrame(aniFn);
            if (s === time) {
                cancelAnimationFrame(aniTimer);
            }
        };
        aniTimer = requestAnimationFrame(aniFn);
    }
    animation(ref, type, duration, aim);
}

export {
    scrollAni
}